<button
  class="png-download-btn"
  [class.png-download-btn--loading]="loading"
  [disabled]="isDisabled"
  [title]="('EXPORT_TO' | translate) + ' PNG'"
  [attr.aria-label]="('EXPORT_TO' | translate) + ' PNG'"
  (click)="download()"
  type="button"
>
  <i *ngIf="!loading; else spinner" class="fa-solid fa-download"></i>
  <ng-template #spinner>
    <i class="fa-solid fa-spinner fa-spin"></i>
  </ng-template>
</button>
